/*
 * Authors: mariushirjanu
 * Created: 31/05/2023
 */
import * as _ from 'underscore';
import { EVENT_ORDER_CHARGES_CHANGED, EVENT_ORDER_TAX_PERCENTAGE_CHANGED } from '../../../../shared/app-events';
import { GaEventService } from '../../../../shared/services/ga-event.service';
import { Injectable } from '@angular/core';
import { IOrderCharge } from '../order-entry-data.service';
import { FormattingService } from '../../../../shared/services/formatting.service';

@Injectable()
export class OrderEntryChargesService {
  private _taxExempt:boolean;
  private _taxPercentage:number;
  private _originalTaxPercentage:number;
  private _charges:IOrderCharge[] = [];

  constructor(
    private eventService:GaEventService,
    private formattingService:FormattingService
  ) {
    /***/
  }

  public getCharges():IOrderCharge[] {
    this._charges = this._charges || [];
    return this._charges;
  }

  public setCharges(charges:any[], editableOwnerTypes:string[]):void {
    charges = charges || this._charges; // take the charges sent by the server or keep the existing ones when 'charges' property is not set

    this._charges = charges.map((charge) => {
      if (charge?.ownerType && editableOwnerTypes?.length) {
        charge.editable = _.contains(editableOwnerTypes, charge.ownerType.id);
      }
      return charge;
    });

    this.eventService.sendMessage(EVENT_ORDER_CHARGES_CHANGED, this._charges);
  }

  public set taxPercentage(taxPercentage:number){
    // format number because 0.14 * 100 = 14.000000000000002
    this._taxPercentage = Number(this.formattingService.formatNumber(taxPercentage));
    this.eventService.sendMessage(EVENT_ORDER_TAX_PERCENTAGE_CHANGED, this._taxPercentage);
  }

  public get taxPercentage():number {
    return this._taxPercentage;
  }

  public originalTaxPercentage(taxPercentage?:number) {
    if (arguments.length) {
      this._originalTaxPercentage = taxPercentage;
    }
    return this._originalTaxPercentage;
  }

  public taxExempt(taxExempt?:boolean) {
    if (arguments.length) {
      this._taxExempt = taxExempt;
    }
    return this._taxExempt;
  }

  public chargesForServer():IOrderCharge[] {
    if (this._charges) {
      const chargesFiltered = this._charges.filter((charge:IOrderCharge) => {
        return charge.manual;
      });
      return chargesFiltered.map((charge:IOrderCharge) => {
        return _.omit(charge, [
          'oldData',
          'editable',
          'editMode',
          'addMode',
          'isDeleted'
        ]);
      });
    }
  }

  public clear():void {
    this._charges = [];
    this._taxExempt = undefined;
    this._originalTaxPercentage = undefined;
    this._taxPercentage = undefined;
  }
}